import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const links = [['Home', '/'], ['Plans', '/plans'], ['About', '/about'], ['Contact', '/contact']];

  return (
    <nav style={{
      position: 'fixed', top: 0, left: 0, right: 0, zIndex: 200,
      background: scrolled ? 'rgba(10,10,10,0.96)' : 'transparent',
      backdropFilter: scrolled ? 'blur(14px)' : 'none',
      borderBottom: scrolled ? '1px solid rgba(46,204,113,0.1)' : 'none',
      transition: 'all 0.35s ease',
      padding: '18px 60px',
      display: 'grid', gridTemplateColumns: '1fr auto 1fr', alignItems: 'center', gap: 20,
    }}>
      {/* Text Logo — left */}
      <Link to="/" style={{ textDecoration: 'none', display: 'flex', alignItems: 'baseline', gap: 2, justifyContent: 'flex-start' }}>
        <span style={{ fontSize: 22, fontWeight: 900, color: '#2ECC71', letterSpacing: -1 }}>MARK</span>
        <span style={{ fontSize: 13, fontWeight: 500, color: '#888', marginLeft: 6 }}>Ms Discoveries</span>
      </Link>

      {/* Centered Nav Links — true center column */}
      <div style={{ display: 'flex', gap: 36, justifyContent: 'center' }}>
        {links.map(([label, href]) => {
          const active = location.pathname === href;
          return (
            <Link key={label} to={href} style={{
              color: active ? '#2ECC71' : '#ccc',
              fontSize: 14, fontWeight: active ? 700 : 500,
              textDecoration: 'none', transition: 'color 0.2s',
              position: 'relative', paddingBottom: 2,
            }}
              onMouseEnter={e => e.currentTarget.style.color = '#2ECC71'}
              onMouseLeave={e => e.currentTarget.style.color = active ? '#2ECC71' : '#ccc'}>
              {label}
              {active && <span style={{ position: 'absolute', bottom: -2, left: 0, right: 0, height: 2, background: '#2ECC71', borderRadius: 2 }} />}
            </Link>
          );
        })}
      </div>

      {/* CTA Buttons — right */}
      <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end' }}>
        <Link to="/client" style={{ padding: '9px 22px', border: '1px solid rgba(46,204,113,0.4)', borderRadius: 8, color: '#2ECC71', fontSize: 13, fontWeight: 600, textDecoration: 'none', transition: 'all 0.2s' }}
          onMouseEnter={e => { e.currentTarget.style.background = 'rgba(46,204,113,0.08)'; }}
          onMouseLeave={e => { e.currentTarget.style.background = 'transparent'; }}>
          Login
        </Link>
        <Link to="/client/register" style={{ padding: '9px 22px', background: '#2ECC71', borderRadius: 8, color: '#000', fontSize: 13, fontWeight: 800, textDecoration: 'none', boxShadow: '0 0 16px rgba(46,204,113,0.3)', transition: 'all 0.2s' }}
          onMouseEnter={e => { e.currentTarget.style.boxShadow = '0 0 24px rgba(46,204,113,0.5)'; }}
          onMouseLeave={e => { e.currentTarget.style.boxShadow = '0 0 16px rgba(46,204,113,0.3)'; }}>
          Get Started
        </Link>
      </div>
    </nav>
  );
}
